// extracted by mini-css-extract-plugin
export default {"LeagueTable":"style_LeagueTable__utXnP","BackPrice":"style_BackPrice__zMgCm","LayPrice":"style_LayPrice__2pyGb"};